<template>
  <b-container class="py-4">
    <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>

    <EditProject
      :project="project"
      v-if="isEditing"
      v-on:project-saved="projectSaved"
      v-on:cancel-edit="cancelEdit"
    />
    <ProjectInfo v-else :project="project" v-on:edit-project="isEditing=!isEditing" />

    <b-card-group deck class="mb-3">
      <b-card class="text-center">
        <i class="fas fa-inbox h1"></i>
        <b-card-title>Reports</b-card-title>
        <b-card-text>Submission and review of submitted project activity reports.</b-card-text>
        <b-button
          variant="outline-primary"
          :to="{name:'reports', params:{uuid:project.id}}"
        >Details</b-button>
      </b-card>
      <b-card class="text-center">
        <i class="far fa-folder-open h1"></i>
        <b-card-title>Resources</b-card-title>
        <b-card-text>Materials for download provided by the expert team.</b-card-text>
        <b-button
          variant="outline-primary"
          :to="{name:'resources', params:{uuid:project.id}}"
        >Details</b-button>
      </b-card>
      <b-card class="text-center">
        <i class="far fa-newspaper h1"></i>
        <b-card-title>News</b-card-title>
        <b-card-text>Submit news about activities that will be published on the grant website.</b-card-text>
        <b-button variant="outline-primary" :to="{name:'news', params:{uuid:project.id}}">Details</b-button>
      </b-card>
      <b-card class="text-center">
        <i class="far fa-calendar-alt h1"></i>
        <b-card-title>Calendar</b-card-title>
        <b-card-text>View and announce events of project activities for all grant partners.</b-card-text>
        <b-button variant="outline-primary" to="/calendar">Details</b-button>
      </b-card>
    </b-card-group>
  </b-container>
</template>

<script>
import ProjectInfo from "@/components/project/ProjectInfo";
import EditProject from "@/components/project/EditProject";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    ProjectInfo,
    EditProject
  },
  data() {
    return {
      isEditing: false
    };
  },
  created() {
    this.getProject()
      .then()
      .catch(err => {
        console.log(err);
      });

    this.$store.commit("setBreadcrumbs", [
      {
        html: "<i class='fas fa-home'></i>",
        to: { name: "home" }
      },
      {
        text: this.project_title,
        to: { name: "project" },
        active: true
      }
    ]);
  },
  computed: {
    ...mapGetters({
      breadcrumbs: "breadcrumbs",
      project: "project/data",
      project_title: "project/title"
    })
  },
  methods: {
    ...mapActions({
      getProject: "project/get"
    }),
    projectSaved() {
      this.makeToast(
        "success",
        "Saved!",
        "Project details for " + this.project.title + " have been saved."
      );
      this.isEditing = false;
    },
    cancelEdit() {
      this.isEditing = false;
    }
  }
};
</script>
<style>
</style>